import { render } from "./EmailSignatureGeneratorPage.vue?vue&type=template&id=5ed35c30"
import script from "./EmailSignatureGeneratorPage.vue?vue&type=script&lang=js"
export * from "./EmailSignatureGeneratorPage.vue?vue&type=script&lang=js"

import "./EmailSignatureGeneratorPage.vue?vue&type=style&index=0&id=5ed35c30&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__